import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionRequiredAuthError, SilentRequest } from '@azure/msal-browser';
import { azureEnvironnent } from 'localEnvironments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private msalService: MsalService) {}

  login() {
    this.msalService.loginRedirect();
  }

  logout() {
    this.msalService.logoutRedirect();
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }


  async getValidToken(): Promise<string | null> {
    const account = this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0];
  
    if (!account) {
      return null;
    }
  
    this.msalService.instance.setActiveAccount(account);
  
    const request: SilentRequest = {
      account,
      scopes: azureEnvironnent.protectedResourceScopes
    };
  
    try {
      const result: AuthenticationResult =
        await this.msalService.instance.acquireTokenSilent(request);
      return result.accessToken;
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        // Choisis popup ou redirect selon ta config
        this.msalService.instance.acquireTokenRedirect(request);
        // ou: await this.msalService.instance.acquireTokenPopup(request);
      } else {
        console.error('Erreur acquireTokenSilent', e);
      }
      return null;
    }
  }
  
}
